(function () {

  const isEnglish = window.location.pathname.startsWith('/en');
  const isCroatian = window.location.pathname.startsWith('/hr');

  // Do nothing on other languages
  if (!isEnglish && !isCroatian) return;

  const map = isEnglish ? {

    // ENGLISH
    "Več sreče prihodnjič!": "Better luck next time!",
    "Več sreče prihodnjič": "Better luck next time!",
    "BREZPLAČNA POŠTNINA": "FREE SHIPPING",

    "Zavrti kolo sreče za popust":
      "Spin the Wheel of Fortune for a Discount",

    "Zavrti kolo sreče in osvoji številne popuste":
      "Spin the Wheel of Fortune and win various discounts!",

    "Vnesi svoje ime in email naslov in zavrti kolo sreče!":
      "Enter your name and email address and spin the wheel of fortune!",

    "Tvoje ime":
      "Your Name",

    "Tvoj email":
      "Your Email",

    "Strinjam se z GDPR pogoji in prijavo na naše e-novičke":
      "I agree to the GDPR terms and subscribe to our newsletter",

    "ZAVRTI KOLO SREČE":
      "SPIN THE WHEEL",

    "ČESTITKE":
      "CONGRATULATIONS",

    "Klikni “Uporabi kodo, ali kopiraj kodo":
      "Click 'Apply Code' or copy the code",

    "Klikni \"Uporabi kodo, ali kopiraj kodo":
      "Click 'Apply Code' or copy the code",

    "Uporabi kodo":
      "Apply Code",

    "Koda dodana!":
      "Code Added!"

  } : {

    // CROATIAN
    "Več sreče prihodnjič!":
      "Više sreće sljedeći put!",

    "Več sreče prihodnjič":
      "Više sreće sljedeći put!",

    "BREZPLAČNA POŠTNINA":
      "BESPLATNA DOSTAVA",

    "Zavrti kolo sreče za popust":
      "Zavrti kotač sreće za popust",

    "Zavrti kolo sreče in osvoji številne popuste":
      "Zavrti kotač sreće i osvoji brojne popuste!",

    "Vnesi svoje ime in email naslov in zavrti kolo sreče!":
      "Unesite svoje ime i email adresu te zavrtite kotač sreće!",

    "Tvoje ime":
      "Vaše ime",

    "Tvoj email":
      "Vaš email",

    "Strinjam se z GDPR pogoji in prijavo na naše e-novičke":
      "Slažem se s GDPR uvjetima i prijavom na naš newsletter",

    "ZAVRTI KOLO SREČE":
      "ZAVRTI KOTAČ",

    "ČESTITKE":
      "ČESTITAMO",

    "Klikni “Uporabi kodo, ali kopiraj kodo":
      "Kliknite 'Primijeni kod' ili kopirajte kod",

    "Klikni \"Uporabi kodo, ali kopiraj kodo":
      "Kliknite 'Primijeni kod' ili kopirajte kod",

    "Uporabi kodo":
      "Primijeni kod",

    "Koda dodana!":
      "Kod je dodan!"
  };

  function translateNode(node) {

    // Translate text nodes
    if (node.nodeType === Node.TEXT_NODE) {
      const trimmed = node.textContent.trim();

      if (map[trimmed]) {
        node.textContent = node.textContent.replace(
          trimmed,
          map[trimmed]
        );
      }
    }

    // Translate element attributes
    if (node.nodeType === Node.ELEMENT_NODE) {

      // Placeholder
      if (
        node.placeholder &&
        map[node.placeholder.trim()]
      ) {
        node.placeholder = map[node.placeholder.trim()];
      }

      // Input value
      if (
        node.value &&
        typeof node.value === "string" &&
        map[node.value.trim()]
      ) {
        node.value = map[node.value.trim()];
      }

      // Recursively translate children
      node.childNodes.forEach(child => translateNode(child));
    }
  }

  function translateWheelify() {
    const wheel = document.querySelector('#wheelify');
    if (!wheel) return;

    translateNode(wheel);
  }

  // Initial translation attempt
  translateWheelify();

  // Observe DOM changes (same logic as your original working script)
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          if (
            node.id === 'wheelify' ||
            node.querySelector?.('#wheelify')
          ) {
            translateWheelify();
          } else {
            translateNode(node);
          }
        }
      });
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();